'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../../helpers/use-debounce';
import { fetchAppellations } from './fetch-appellations';

type Props = {
  isOpen: boolean;
  term: string | null;
};

export const useAppellationsAutocomplete = (props: Props) => {
  const { isOpen, term } = props;
  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['appellations-autocomplete', termDebounced] : null),
    ([_, term]) => fetchAppellations(client, term)
  );
};
